<template>
<!--   <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view />
</template>

<script>
import { defineComponent, reactive, computed, ref, toRefs, onMounted } from "vue";
	import { useRoute } from 'vue-router';
	import '@/assets/css/base.css';
	import '@/utils/rem.js';
	import {languageInit} from "@/utils/util";
  import { useI18n } from 'vue-i18n';
  import { useStore } from "vuex";
  import { supportedLanguages } from '@/utils/config';

	export default {
    name: 'Home',
    setup(){
      const $i18n = useI18n();
      const $route = useRoute();
      const $store = useStore();
      const query = computed(() => $route.query);
      const languageInita = async ()=>{
      
        let lang = ''
        if($route.query.language!=undefined&&$route.query.language!='') lang = $route.query.language;
        if(lang){
                  const targetLang = supportedLanguages.filter((item)=>item.lang.indexOf(lang)>-1);
                  if(targetLang.length>0){
                      lang = targetLang[0].lang;
                  }
        }
              
        $i18n.locale.value = await languageInit(lang);
        $store.commit('SETLANGUAGE',lang)
      }
      //languageInita()
    }
  }
  </script>